<div id="panel-1" role="tabpanel" aria-labelledby="tab-1" class="two-column-layout indication-wrapper use-case-wrapper">
    <ng-container *ngFor="let consentUseCase of consentUseCases">
        <app-card
                [tabindex]="2"
                [cardPadding]="'32'"
                [cardMainTitle]="consentUseCase.title"
                [cardParagraph]="consentUseCase.description"
                [ariaLabel]="consentUseCase.title + ('GENERAL.USE_CASE' | translate)"
                (cardClickEvent)="useCaseStepEvent.emit(consentUseCase)">
        </app-card>
    </ng-container>
</div>
